module.exports = __webpack_public_path__ + "img/recipe-add-white.31edfc30.svg";